import React, { useState } from 'react';
import { Table as HefestoTable } from '@gerdau/hefesto-mais-web';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import { IExtraItensState } from '../../../../../store/ducks/fabrication-purchase-order/types';
import {
  IDiameter,
  ISteelType
} from '../../../../../store/ducks/fabrication/types';
import CheckoutTableHeader from '../CheckoutTableHeader';
import { CheckoutContainer, TableContainer } from '../styles';

interface FabricationCheckoutExtraItensTableDataSource {
  key: number;
  pieceType: string;
  steelType: string;
  diameter: string; // bitola
  measure_a: string;
  measure_b: string;
  measure_c: string;
  quantity: string;
  partWeight: string;
}

interface IExtraItensTableProps {
  goToExtraItens(): void;
  extraItens: IExtraItensState;
  isGeneratingPdf?: boolean;
}

const ExtraItensTable: React.FC<IExtraItensTableProps> = ({
  extraItens,
  goToExtraItens,
  isGeneratingPdf = false
}) => {
  const pieceTypesState = useSelector(
    (appState: ApplicationState) => appState.fabrication.pieceTypesState
  );
  const steelTypesState = useSelector(
    (appState: ApplicationState) => appState.fabrication.steelTypesState
  );

  const getDataTable = (): FabricationCheckoutExtraItensTableDataSource[] => {
    const dataTable: FabricationCheckoutExtraItensTableDataSource[] = [];

    const getPieceTypeName = (pieceTypeId?: number): string => {
      const pieceType = pieceTypesState?.pieceTypes.find(
        (piece) => piece.id === pieceTypeId
      );
      return pieceType?.description || ' - ';
    };

    const getSteelType = (steelTypeId?: number): ISteelType | undefined => {
      const steelType = steelTypesState?.steelTypes.find(
        (steel) => steel.id === steelTypeId
      );
      return steelType;
    };

    const getDiameter = (
      diameters: IDiameter[],
      diameterId?: number
    ): string => {
      const diameter = diameters.find((dmt) => dmt.id === diameterId);
      return diameter ? `${diameter.size} mm` : ' - ';
    };
    const getPiecesPlural = (amount: number) => {
      return amount > 1 ? 'peças' : 'peça';
    };

    extraItens.otherPieces
      .filter((extraItem) => extraItem.pieceTypeId)
      .forEach((extraItem, idx) => {
        const steelType = getSteelType(extraItem.steelTypeId);

        dataTable.push({
          key: idx,
          pieceType: getPieceTypeName(extraItem.pieceTypeId),
          steelType: steelType?.description || ' - ',
          diameter:
            steelType && steelType.diametersState?.diameters
              ? getDiameter(
                  steelType.diametersState?.diameters,
                  extraItem.diameterId
                )
              : ' - ',
          measure_a: extraItem.measureA ? `${extraItem.measureA} cm` : ' - ',
          measure_b: extraItem.measureB ? `${extraItem.measureB} cm` : ' - ',
          measure_c: extraItem.measureC ? `${extraItem.measureC} cm` : ' - ',
          quantity: extraItem.amount
            ? `${extraItem.amount} ${getPiecesPlural(extraItem.amount)}`
            : ' - ',
          partWeight:
            extraItem.weight !== undefined ? `${extraItem.weight} kg` : ' - '
        });
      });

    return dataTable;
  };

  const [fabricationExtraItensData] = useState<
    FabricationCheckoutExtraItensTableDataSource[]
  >(getDataTable());

  const getColumns = () => {
    const columns = [
      {
        title: 'Tipo da peça',
        dataIndex: 'pieceType',
        render: (text: string) => <span>{text}</span>
      },
      {
        title: 'Tipo de aço',
        dataIndex: 'steelType',
        render: (text: string) => <span>{text}</span>
      },
      {
        title: 'Bitola',
        dataIndex: 'diameter',
        render: (text: string) => <span>{text}</span>
      },
      {
        title: 'Medida a',
        dataIndex: 'measure_a',
        render: (text: string) => <span>{text || ' - '}</span>
      },
      {
        title: 'Medida b',
        dataIndex: 'measure_b',
        render: (text: string) => <span>{text || ' - '}</span>
      },
      {
        title: 'Medida c',
        dataIndex: 'measure_c',
        render: (text: string) => <span>{text || ' - '}</span>
      },
      {
        title: 'Quantidade',
        dataIndex: 'quantity',
        render: (text: string) => <span>{text || ' - '}</span>
      },
      {
        title: 'Peso',
        dataIndex: 'partWeight',
        render: (text: string) => <span>{text || ' - '}</span>
      }
    ];

    return columns;
  };

  return (
    <CheckoutContainer>
      {!isGeneratingPdf && (
        <CheckoutTableHeader
          title="Itens extras"
          onEditClick={goToExtraItens}
        />
      )}

      <TableContainer>
        <HefestoTable
          columns={getColumns()}
          dataSource={fabricationExtraItensData}
          pagination={false}
          scroll={{
            x: 'max-content'
          }}
        />
      </TableContainer>
    </CheckoutContainer>
  );
};

export default ExtraItensTable;
